import React, { useState } from 'react';
import Tree from "react-d3-tree";
import { Link, useHistory } from "react-router-dom";
import PageLayout from "./PageLayout";
import Loading from "./Loading";
import roles from "../auth/roles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from "reactstrap";
import Can from "../auth/Can";
import { useAuth0 } from "../auth/react-auth0-wrapper";
import { deleteUserFromTenant } from "../api/users";


const getcolor = type => {
  if (type === "dealer") return "primary";
  if (type === roles.AGENTE) return "info";
  if (type === roles.VENDITORE) return "warning";
  if (type === roles.DEALER) return "dark";
  if (type === roles.MARKETING) return "danger";
  if (type === roles.SERVICE) return "success";
  if (type === roles.BACKOFFICE) return "first";
  return "primary";
};


const getHierarchyActions = node => {
  const type = node.attributes.type

  if (type !== "dealer") return null;

  return (
    <div>
      <Row>
        <Col>
          <div className="action-container">
            <Link
              className={`mt-2 btn btn-${getcolor(type)} p-button-icon-only`}
              to={`/admin/add-tenant-child/${node._id}`}
            >
              <i className="pi pi-plus"></i> Crea e associa Filiale
            </Link>
            <Link
              className={`mt-2 btn btn-${getcolor(
                roles.VENDITORE
              )} p-button-icon-only`}
              to={`/admin/add-tenant-user/${roles.VENDITORE}/${node._id}`}
            >
              <i className="fas fa-link"></i> Associa Venditore
            </Link>
            <Link
              className={`mt-2 btn btn-${getcolor(roles.AGENTE)} p-button-icon-only`}
              to={`/admin/add-tenant-user/${roles.AGENTE}/${node._id}`}
            >
              <i className="fas fa-link"></i> Associa Agente
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="action-container">
            <Link
              className={`mt-2 btn btn-${getcolor(
                roles.MARKETING
              )} p-button-icon-only`}
              to={`/admin/add-tenant-user/${roles.MARKETING}/${node._id}`}
            >
              <i className="fas fa-link"></i> Associa Marketing
            </Link>
            <Link
              className={`mt-2 btn btn-${getcolor(roles.DEALER)} p-button-icon-only`}
              to={`/admin/add-tenant-user/${roles.DEALER}/${node._id}`}
            >
              <i className="fas fa-link"></i> Associa Dealer
            </Link>
            <Link
              className={`mt-2 btn btn-${getcolor(
                roles.SERVICE
              )} p-button-icon-only`}
              to={`/admin/add-tenant-user/${roles.SERVICE}/${node._id}`}
            >
              <i className="fas fa-link"></i> Associa Service
            </Link>
            <Link
              className={`mt-2 btn btn-${getcolor(
                roles.BACKOFFICE
              )} p-button-icon-only`}
              to={`/admin/add-tenant-user/${roles.BACKOFFICE}/${node._id}`}
            >
              <i className="fas fa-link"></i> Associa Backoffice
            </Link>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const exploreEntityActions = (node, onExplore, setModal) => {

  const type = node.attributes.type

  return (
    <div>
      <Row>
        <Col>
          <div className="action-container mt-2">
            {type === "dealer" ? (<Button
              color="success"
              title="Imposta come Dealer attivo"
              onClick={() => {
                setModal(false)
                onExplore(node._id);
              }}
              className="p-button-icon-only"
            >
              <FontAwesomeIcon icon="eye" /> Imposta come Dealer attivo
            </Button>) : null}
          </div>
        </Col>
      </Row>
    </div>
  );
}

const NodeLabel = ({ className, nodeData, onSelectItem }) => {

  return (
    <div
      key={`nd-${nodeData.name}`}
      className={className}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }}
    >
      <Button
        id={`nd-${nodeData.name}`}
        type="button"
        onClick={() => onSelectItem(nodeData)}
        color={getcolor(nodeData.attributes.type)}
      >
        <div>
          {`${nodeData.attributes.name} ${nodeData.attributes.surname || ""}`}
        </div>
        <div>
          {`${nodeData.attributes.type.toUpperCase()}`}
        </div>
        <div>
          <FontAwesomeIcon icon="phone" />{` ${nodeData.attributes.phone}`}
        </div>
        <div>
          <FontAwesomeIcon icon="envelope" />{` ${nodeData.attributes.email}`}
        </div>
      </Button>
    </div>
  );
};

const Hierarchy = ({ loading, data, title, nav, onExplore }) => {
  const container = React.createRef();
  const [position, setPosition] = React.useState();
  const [modal, setModal] = React.useState(false);
  const [selEntity, setSelEntity] = React.useState();
  const toggle = () => setModal(!modal);
  const { push } = useHistory();

  const onSelectItem = entity => {
    setSelEntity(entity);
    setModal(true);
  };

  const containerStyles = {
    width: "100%",
    height: "100vh"
  };

  const treeStyles = {
    links: { stroke: "gray", strokeWidth: 4 },
    nodes: {
      node: {
        circle: { fill: "white", cursor: "pointer" }
      },
      leafNode: {
        circle: { fill: "#6f6f6f", cursor: "default" }
      }
    }
  };

  React.useEffect(() => {

    if (data && data.length && !loading) {
      const dimensions = container.current.getBoundingClientRect();
      setPosition({
        x: dimensions.width / 2,
        y: 60
      });
    }
  }, [data, loading]);

  if (loading || !data || !data.length) {
    return <Loading />;
  }

  const { geo } = useAuth0();

  const unlinkConfirm = async selEntity => {
    const proceed = confirm(`Confermi la rimozione dell'associazione con ${selEntity.attributes.surname} ${selEntity.attributes.name}?`);
    if (!proceed) {
      return;
    }
    try {
      await deleteUserFromTenant(selEntity.node_id);
    } finally {
      push("/");
      push("/tenant/structure");
    }
  };

  return (
    <PageLayout title={`Struttura Dealer: ${data[0].attributes.name}`} optionalNav={nav}>
      <Row>
        <Col>
          <div className={`p-2 mt-1 text-center text-white bg-${getcolor("dealer")}`}>
            DEALER
          </div>
        </Col>
        <Col>
          <div className={`p-2 mt-1 text-center text-white bg-${getcolor(roles.VENDITORE)}`}>
            VENDITORE
          </div>
        </Col>
        <Col>
          <div className={`p-2 mt-1 text-center text-white bg-${getcolor(roles.AGENTE)}`}>
            AGENTE
          </div>
        </Col>
        <Col>
          <div className={`p-2 mt-1 text-center text-white bg-${getcolor(roles.DEALER)}`}>
            DEALER ADMIN
          </div>
        </Col>
        <Col>
          <div className={`p-2 mt-1 text-center text-white bg-${getcolor(roles.MARKETING)}`}>
            MARKETING
          </div>
        </Col>
        <Col>
          <div className={`p-2 mt-1 text-center text-white bg-${getcolor(roles.SERVICE)}`}>
            SERVICE
          </div>
        </Col>
        <Col>
          <div className={`p-2 mt-1 text-center text-white bg-${getcolor(roles.BACKOFFICE)}`}>
            BACKOFFICE
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div id="treeWrapper" style={containerStyles} ref={container}>
            <Tree
              data={data}
              translate={position}
              orientation={"vertical"}
              allowForeignObjects
              styles={treeStyles}
              pathFunc={"step"}
              separation={{ siblings: 1.8, nonSiblings: 1.8 }}
              nodeLabelComponent={{
                render: (
                  <NodeLabel
                    className="hierarchyItem"
                    onSelectItem={onSelectItem}
                  />
                ),
                foreignObjectWrapper: {
                  y: 10,
                  x: -125,
                  width: "100%",
                  height: "100%"
                }
              }}
            />
          </div>
        </Col>
      </Row>
      {selEntity && (
        <Modal isOpen={modal} centered size="md" toggle={toggle}>

          <ModalHeader toggle={toggle}>{selEntity.attributes.type.toUpperCase()}:</ModalHeader>

          <ModalBody>
            <Row>
              <Col>
                <div>
                  <strong className="mr-2">Nominativo:</strong>
                  {`${selEntity.attributes.name} ${selEntity.attributes.surname || ""}`}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div>
                  <strong className="mr-2">C.F./P.iva:</strong>
                  {`${selEntity.attributes.taxCode || ""} ${selEntity.attributes
                    .vatCode || ""}`}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div>
                  <strong className="mr-2">Indirizzo:</strong>
                  {`${selEntity.attributes.street ? selEntity.attributes.street : ""} - ${
                    selEntity.attributes.cap ? selEntity.attributes.cap : ""
                    } ${selEntity.attributes.city ?
                      geo.getComuneLabel(selEntity.attributes.city) : ""
                    } (${selEntity.attributes.province ? selEntity.attributes.province.toUpperCase() : ""})`}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div>
                  <strong className="mr-2">Email:</strong>
                  {`${selEntity.attributes.email}`}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div>
                  <strong className="mr-2">Telefono:</strong>
                  {`${selEntity.attributes.phone}`}
                </div>
              </Col>
            </Row>
            {selEntity.attributes.type === "dealer" && (
              <Row>
                <Col>
                  <div>
                    <strong className="mr-2">Riferimento:</strong>
                    {selEntity.attributes.reference1}
                  </div>
                </Col>
              </Row>
            )}
          </ModalBody>

          <ModalFooter className="text-center">
            <div>
              <Can
                roles={[roles.ADMIN]}
                yes={() =>
                  <div>
                    {getHierarchyActions(selEntity)}
                    {exploreEntityActions(selEntity, onExplore, setModal)}
                  </div>
                }
                no={() => <Can
                  roles={[roles.AGENTE, roles.VENDITORE]}
                  yes={() =>
                    <div>
                      {exploreEntityActions(selEntity, onExplore, setModal)}
                    </div>
                  }
                  no={() => null}
                />}
              />
              <div className="mt-2">
                {selEntity.attributes.type !== "dealer" && (
                  <Can
                    roles={[roles.ADMIN]}
                    yes={() =>
                      <div className="float-left mr-2">
                        <Button
                          color="danger"
                          onClick={() => { unlinkConfirm(selEntity) }}
                        >
                          <FontAwesomeIcon icon="unlink" /> Dissocia
                  </Button>
                      </div>
                    }
                    no={() => null}
                  />
                )}
                <Button
                  className="float-right "
                  color="primary"
                  onClick={() => { setModal(false) }}
                >
                  <FontAwesomeIcon icon="times" /> Chiudi
            </Button>
              </div>
            </div>
          </ModalFooter>

        </Modal>
      )}
      <Button
        onClick={() => push('/')}
        color="warning"
        className="btn btn-warning mt-2 float-right"
      >
        <FontAwesomeIcon icon="reply" /> Torna
      </Button>

    </PageLayout>
  );
};

export default Hierarchy;
